import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MaintenanceService } from '../../services/maintenanceService';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ExportDataService } from '../../../shared';
import { SharedAuthService } from '../../../shared/shared.auth.service';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-enterprise-initiative-role-management',
  templateUrl: './enterprise-initiative-role-management.component.html',
  styleUrl: './enterprise-initiative-role-management.component.css',
  standalone: false
})
export class EnterpriseInitiativeRoleManagementComponent implements OnChanges {
  enabledInitiatives: Array<any> = [];
  @Input() initiativeList: any = [];
  isUserAdmin: any;
  enableRemove: boolean = false;
  clearFormFields: boolean = false;
  allRowsExpanded: boolean = false;
  olddatasource: any;
  isInitialSearch: boolean;
  noRoleUpdate:boolean = false;
  constructor(
    public maintenanceService: MaintenanceService,
    private router: Router,
    public dialog: MatDialog,
    private toaster: ToastrService,
    public exportService: ExportDataService,
    private sharedAuthService : SharedAuthService
  ) {
  }

  public showLoader: boolean = false;
  TABLE_CONFIG: any = {
    pageSize: [10, 20, 40],
    pageIndex: 0,
    totalItems: 0,
    selection: true,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: true,
    innerTableEdit: false
  };
  searchField: any;


  data = [];

  DATA_SCHEMA = {
    'all-checkbox': 'checkbox',
    Lob: 'text',
    lobId: 'text',
    subLobID: 'text',
    Sub_LOB: 'text',
    displayName: 'text'
  };

  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  hierarchyDropdownConfig = {
    parentfield: ['SegID', 'MasterSegment'],
    firstchildfield: ['lob_id', 'lob'],
    secondchildfield: ['SubLobID', 'sub_lob', 'subLob'],
    firstchildkey: 'lob',
    secondchildkey: 'subLob',
  };
  tabledata: any = [];
  dataSourceDetails: MatTableDataSource<any>;
  selectedRow: any = [];
  sort: any;
  lobdropdwnDataSource = [];
  @ViewChild('modalAddRole', { static: false }) modalAddRole;
  @Input() selectedInitiative: any;

  TABLE_COLUMNS: any = [
    {
      key: 'Master_Segment',
      labelKey: "SegID",
      label: 'Segment',
      width: '10.5% !important',
      addNew: false,
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': true }],
      padding: '5px 5px 5px 24px !important'
    },
    {
      key: 'lobId',
      width: '7% !important',
      label: 'LOB ID',
      search: '',
      searchValue: '',
      padding: '5px 5px 5px 0 !important'
    },
    {
      key: 'lob',
      labelKey: "lob",
      width: '13% !important',
      addNew: true,
      label: 'LOB',
      edit: false,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'subLobCount',
      label: 'Sub LOB Count',
      width: '10% !important',
      align: 'center !important'
    },
    {
      key: 'Actions',
      label: 'Actions',
      width: '10% !important',
      align: 'center !important',
      padding: '5px 5px 5px 0px !important'
    }
  ];

  expandAll: string = 'false';
  expanded_columns: any = [

    {
      key: 'subLobID',
      labelKey: 'subLobID',
      label: 'Sub LOB ID',
      width: '12% !important',
      edit: true,
      addNew: true,
      search: '',
      searchValue: '',
    },
    {
      key: 'Sub_LOB',
      labelKey: "SubLineofBusiness",
      label: 'Sub LOB',
      width: '20.3% !important',
      addNew: true,
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'role',
      labelKey: "role",
      label: 'Role',
      width: '12% !important',
      addNew: true,
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'Users',
      labelKey: "Users",
      label: 'Users',
      width: '10% !important',
      addNew: true,
      edit: true,
      filter: true,
      search: '',
      searchValue: '',
      validations: [{ 'required': true }],
      padding: '5px 15px 5px 0px !important'
    },
    {
      key: 'Actions',
      label: '',
      width: '13% !important',
      padding: "5px 5px 5px 5px"
    }
  ];

  ngOnChanges(): void {
    if (this.selectedInitiative) {
      this.noRoleUpdate=false;
      this.getEIRoleList(this.selectedInitiative.initiative_ID);
    }
  }

  ngOnInit() {
    if (!sessionStorage.getItem('techaccessData')) {
      this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
        this.checkAccess();
      });
    } else {
      this.checkAccess();
    }
  }
  checkAccess() {
    const isAdminRole = this.sharedAuthService.checkAdminSGAccess();
    const accessData = this.sharedAuthService.getTechAccessData();
    this.isUserAdmin =
      isAdminRole && accessData && accessData['Role'] && accessData['Role'] == 'Admin'
        ? true
        : false;

    if (this.isUserAdmin == true) {
      this.TABLE_CONFIG.innerTableEdit = true;
      this.getLobdata();
    }
  }
  getLobdata() {
    this.showLoader = true;
    this.maintenanceService.getLOBList().subscribe(
      (response: any) => {
        if (response && response.length) {
          this.showLoader = false;
          this.lobdropdwnDataSource = this.formatList(response);
        }
      },
      err => {
        this.showLoader = false;
        this.showErrMsg(err);
      }
    );
  }

  expandAllFunc() {
    if (this.expandAll == 'true' || this.allRowsExpanded == true) {
      if (this.expandAll == 'false')
        this.expandAll = 'false1';
      else
        this.expandAll = 'false';
      this.allRowsExpanded = false;
    }
    else {
      this.expandAll = 'true';
      this.allRowsExpanded = true;
    }
  }



  searchDataSet(event: any): void {
    this.isInitialSearch = false;
    const filterValue = this.getFilterValue(event);
  
    this.prepareChildDataSources();
    this.setupMainDataSource(filterValue);
  
    const lobFilteredData = this.dataSourceDetails.filteredData;
    const subLobFilteredData = this.getFilteredSubLobData(lobFilteredData, filterValue);
  
    this.updateDataSource(subLobFilteredData, filterValue);
    this.updateExpandState(filterValue);
  }
  
  private getFilterValue(event: any): string {
    return event ? (event.target as HTMLInputElement).value.trim().toLowerCase() : '';
  }
  
  private prepareChildDataSources(): void {
    this.olddatasource.forEach(element => {
      element.childDataSource = new MatTableDataSource(element.subLob);
  
      element.childDataSource.filterPredicate = (data, filter: string): boolean => {
        const foundInUsers = data.Users?.some(user =>
          user?.toLowerCase().includes(filter.toLowerCase())
        );
  
        return (
          data.Sub_LOB?.toLowerCase().includes(filter) ||
          data.subLobID?.toLowerCase().includes(filter) ||
          foundInUsers
        );
      };
    });
  }
  
  private setupMainDataSource(filterValue: string): void {
    this.dataSourceDetails = new MatTableDataSource(this.olddatasource);
    this.dataSourceDetails.filterPredicate = (data, filter: string): boolean => {
      return (
        data.lob?.toLowerCase().includes(filter) ||
        data.Master_Segment?.toLowerCase().includes(filter) ||
        data.lobId?.toLowerCase().includes(filter)
      );
    };
    this.dataSourceDetails.filter = filterValue;
  }
  
  private getFilteredSubLobData(lobFilteredData: any[], filterValue: string): any[] {
    return this.dataSourceDetails.data.filter((element: any) => {
      const isInLob = lobFilteredData.some(el => el.id === element.id);
      if (isInLob) return true;
  
      element.childDataSource.filter = filterValue;
      return element.childDataSource.filteredData.length > 0;
    });
  }
  
  private updateDataSource(filteredData: any[], filterValue: string): void {
    if (filteredData.length) {
      this.dataSourceDetails = new MatTableDataSource(filteredData);
    } else {
      this.dataSourceDetails = new MatTableDataSource(this.olddatasource);
      this.dataSourceDetails.filter = filterValue;
    }
  
  }
  
  private updateExpandState(filterValue: string): void {
    setTimeout(() => {
      const shouldExpand = filterValue !== '';
      this.expandAll = shouldExpand ? 'true' : 'false';
      this.allRowsExpanded = shouldExpand;
    }, 500);
  }

  collapseAllFunc(data) {
    if (data == true) {
      this.allRowsExpanded = true;
    }
    else {
      this.allRowsExpanded = false;
    }
  }

  getSelectedIni(event) {
    if (event.data && event.data.initiative_ID) {
      this.selectedInitiative = event.data;
      this.getEIRoleList(this.selectedInitiative.initiative_ID);
    }
  }

  AddNewEntry() {
    this.modalAddRole.show();
    this.clearFormFields = false;
  }
  formatList(list: any) {
    const filterValues = [...new Set(list.map(ele => ele.master_segment))];
    const finalList: any = [];
    filterValues.forEach((ele: any) => {
      const filteredList = list.filter(item => ele == item.master_segment);

      const tempobj = {
        MasterSegment: filteredList[0]?.master_segment,
        lob: filteredList
      };
      finalList.push(tempobj);
    });

    return finalList;
  }



  getEIRoleList(data: any) {
    const payload = { initiativeID: data };
    this.showLoader = true;
  
    this.maintenanceService.getEnabledInitiativesRoleList(payload).subscribe(
      (response: any) => this.handleRoleListResponse(response),
      (error: any) => this.handleRoleListError(error)
    );
  }
  
  private handleRoleListResponse(response: any): void {
    this.showLoader = false;
  
    if (response && response.length) {
      const dataset = this.transformRoleListData(response);
      this.updateTableData(dataset);
    } else {
      this.noRoleUpdate = true;
    }
  }
  
  private handleRoleListError(error: any): void {
    this.showLoader = false;
    this.showErrMsg(error);
    this.TABLE_CONFIG.totalItems = 0;
  }
  
  private transformRoleListData(data: any[]): any[] {
    return data
      .sort((a, b) => a.lob.localeCompare(b.lob))
      .map((ele, index) => {
        const subLobData = this.transformSubLobData(ele.subLob, ele);
        return {
          ...ele,
          subLob: subLobData,
          subLobCount: subLobData.length,
          id: index,
          childDataSource: new MatTableDataSource(subLobData)
        };
      });
  }
  
  private transformSubLobData(subLob: any[], parent: any): any[] {
    return subLob
      .sort((a, b) => a.Sub_LOB.localeCompare(b.Sub_LOB))
      .map((i) => ({
        ...i,
        Users: this.transformUsersArray(i.users), // Ensure Users is an array of strings
        LobID: parent.lobId,
        CIOLOB: parent.lob,
        MasterSegment: parent.Master_Segment
      }));
  }
  
  private transformUsersArray(users: any[]): string[] {
    return users
      ? users
          .map((user) => user.displayName)
          .sort((a, b) => a.localeCompare(b))
      : [];
  }
  
  private updateTableData(dataset: any[]): void {
    this.tabledata = dataset;
    this.olddatasource = dataset;
    this.expandAll = 'false';
    this.allRowsExpanded = false;
    this.searchField = '';
    this.dataSourceDetails = new MatTableDataSource(dataset);
    this.TABLE_CONFIG['TABLE_CLASS'] = 'ei-role-tble-container';
    this.TABLE_CONFIG.totalItems = dataset.length;
  }



  closemodal() {
    this.clearFormFields = true;
  }

  exportToExcel() {
    const exportData = [];
    this.dataSourceDetails.data.forEach(element => {
      element.subLob.forEach(each => {
        const exportJSON: any = {};
        exportJSON['Master Segment'] = element.Master_Segment;
        exportJSON['LOB ID'] = element.lobId;
        exportJSON['LOB Name'] = element.lob;
        exportJSON['SUBLOB ID'] = each.subLobID;
        exportJSON['SUBLOB Name'] = each.Sub_LOB;
        exportJSON['Role'] = each.role;
        exportJSON['Name'] = each.users
          ? each.users
            .map(x => (x.displayName ? x.displayName.split(",").join("") : ""))
            .join(", ")
          : "";
        exportData.push(exportJSON);
      });
    });
    this.exportService.exportToExcel('EnterpriseInitiatives Role', [exportData]);
  }

  saveEvent(payload) {
    this.modalAddRole.hide();
    this.showLoader = true;
    this.clearFormFields = true;
    this.maintenanceService.updateEIRole(payload).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response && response.message && !response.status) {
          this.showSuccessMsg(response.message);
          this.getEIRoleList(this.selectedInitiative.initiative_ID);
        } else if (response && response.status) {
          this.showErrMsg(response.message);
        }
      },
      err => {
        this.showLoader = false;
        this.showErrMsg(err);
      }
    );
  }

  showErrMsg(err: any) {
    this.showLoader = false;
    if (err && err.message) {
      this.toaster.error(err.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  showSuccessMsg(msg: any) {
    this.showLoader = false;
    if (msg) {
      this.toaster.success(msg, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  notifyToParentInitiative() {
    this.getEIRoleList(this.selectedInitiative.initiative_ID);
  }

    navigateToLOBManagement() {
      this.router.navigate(["maintenance"], {
          queryParams: { selectedTab: 'lob' },
        });
  }
}
